import { Col, Row } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Form from "shared/components/Form";
import Input from "shared/components/Form/Input";
import Header from "shared/components/Header";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { bindInputProps } from "utils/helpers";
import validation from "./validation";

const Detail = ({ onSubmit, webhook, cancel }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.WEBHOOK);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });
  const { name, description, url, organization } = webhook;
  return (
    <Formik
      initialValues={{ name, description, url, organization: organization.id }}
      onSubmit={onSubmit}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
      )}
    >
      {({ isValid, handleSubmit, ...formProps }) => [
        <Header
          key={"header"}
          title={DETAIL.HEADER.TITLE}
          subtitle={DETAIL.HEADER.ACTION}
          actions={[
            {
              text: DETAIL.HEADER.DISCARD,
              onClick: cancel,
              variant: "outlined",
            },
            {
              text: DETAIL.HEADER.SAVE,
              onClick: handleSubmit,
            },
          ]}
        />,
        <Row gutter={[16, 16]} key={"row"}>
          <Col span={24}>
            <Form title={FORM.GENERAL_INFO}>
              <Col lg={12}>
                <Input
                  placeholder={FORM.NAME}
                  {...bindInputProps({ name: "name", ...formProps })}
                />
              </Col>
              <Col>
                <Input
                  placeholder={FORM.DESCRIPTION}
                  {...bindInputProps({
                    name: "description",
                    ...formProps,
                  })}
                />
              </Col>
              <Col>
                <Input
                  placeholder={FORM.URL}
                  {...bindInputProps({
                    name: "url",
                    ...formProps,
                  })}
                />
              </Col>
              <Col>
                <Select
                  type="async"
                  node={[
                    graphql.queries.ORGANIZATIONS,
                    {
                      variables: { where: {} },
                    },
                    "organizations.data",
                  ]}
                  placeholder={FORM.ORGANIZATION}
                  {...bindInputProps({
                    name: "organization",
                    ...formProps,
                  })}
                />
              </Col>
            </Form>
          </Col>
        </Row>,
      ]}
    </Formik>
  );
};

export default Detail;
